var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66658 7.25021C9.66658 9.73198 8.13936 10.821 6.95921 11.1883C6.70755 11.2666 6.54216 10.9732 6.6927 10.7569C7.20626 10.0188 7.79992 8.89279 7.79992 7.83354C7.79992 6.69569 6.84088 5.35233 6.09199 4.52376C5.92078 4.33434 5.62214 4.45968 5.6128 4.71484C5.58187 5.56021 5.44847 6.69124 4.87323 7.57766C4.78064 7.72034 4.58409 7.73217 4.4786 7.59875C4.29886 7.37144 4.11913 7.09064 3.9394 6.86882C3.84259 6.74933 3.66761 6.74769 3.55594 6.85342C3.12057 7.26567 2.51103 7.90853 2.51103 8.70854C2.51103 9.25096 2.72118 9.81964 2.95829 10.2772C3.08873 10.5289 2.85679 10.8319 2.60576 10.7001C1.56587 10.1544 0.333252 9.04899 0.333252 7.25021C0.333252 5.41477 2.84759 2.87218 3.80762 0.470067C3.9591 0.0910224 4.42597 -0.0870898 4.75068 0.160266C6.71721 1.6583 9.66658 4.5541 9.66658 7.25021Z",
    fill: "url(#paint0_linear_226_85)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_226_85",
    x1: 0.333252,
    y1: 7.21727,
    x2: 9.66658,
    y2: 7.21727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7957FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A824E6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.b56a9f8dcb82968eee60df93e676b0ad.svg";
export { ForwardRef as ReactComponent };